import { render, staticRenderFns } from "./ShipmentAdd.vue?vue&type=template&id=4dab724b&"
import script from "./ShipmentAdd.vue?vue&type=script&lang=js&"
export * from "./ShipmentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShipmentAdd.vue"
export default component.exports